import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import ButtonTsoPq from '@components/Buttons/ButtonTsoPq';
import ProgressBarTsoPq from '@components/LoadingSpinners/ProgressBarTsoPq';
import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UploadListTsoPq from './UploadList';

type UploadingFilesTsoPqProps = {
  errorFiles: File[] | [];
  currentFileIndex: number;
  totalFiles: number;
  handleModalState: (state: boolean) => void;
};

const StyledUploadContent = styled(Box)(() => {
  return {
    width: '53.125rem',
    display: 'flex',
    flexDirection: 'column',
    padding: '1.5rem 0',
    gap: '2rem',
  };
});

const StyledUploadDescritpion = styled(Typography)(() => {
  return {
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    fontFamily: tsoPqTheme.typography.openSans,
    fontWeight: '400',
    fontSize: tsoPqTheme.typography.fontsize_support_support_text_medium,
    lineHeight: tsoPqTheme.typography.lineHeight_l,
    verticalAlign: 'middle',
  };
});

const StyledProgressContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.125rem',
  };
});

const StyledProgressDescription = styled(Typography)(() => {
  return {
    textAlign: 'end',
  };
});

const StyledErrorList = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.125rem',
  };
});

const StyledTitle = styled(Typography)(() => {
  return {
    fontFamily: tsoPqTheme.typography.openSans,
    fontWeight: 500,
    fontSize: tsoPqTheme.typography.fontsize_title_list_section_small,
    lineHeight: tsoPqTheme.typography.lineHeight_m,
    verticalAlign: 'middle',
  };
});

const StyledUploadingContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  };
});

const StyledButtonWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    justifyContent: 'flex-end',
  };
});

const UploadingFilesTsoPq = ({
  errorFiles,
  currentFileIndex,
  totalFiles,
  handleModalState,
}: UploadingFilesTsoPqProps) => {
  const { t } = useTranslation();

  return (
    <StyledUploadContent>
      <StyledUploadingContainer>
        {currentFileIndex + errorFiles.length < totalFiles && (
          <StyledUploadDescritpion>{t('upload.fileUpload.uploadingFile.description')}</StyledUploadDescritpion>
        )}
        <StyledProgressContainer>
          <ProgressBarTsoPq variant="determinate" value={((currentFileIndex + errorFiles.length) / totalFiles) * 100} />
          <StyledProgressDescription>
            {t('upload.fileUpload.uploadingFile.progress')
              .replace('[currentFile]', `${currentFileIndex}`)
              .replace('[totalFiles]', `${totalFiles}`)}
          </StyledProgressDescription>
        </StyledProgressContainer>
      </StyledUploadingContainer>
      {errorFiles.length > 0 && (
        <StyledErrorList>
          <StyledTitle>{t('upload.fileUpload.uploadingFile.errorList.title')}</StyledTitle>
          <UploadListTsoPq files={errorFiles} error />
        </StyledErrorList>
      )}
      <StyledButtonWrapper>
        <ButtonTsoPq
          buttonType={currentFileIndex === totalFiles ? 'filledPrimary' : 'disabledFilled'}
          textContent={t('upload.fileUpload.closeWindow')}
          disabled={currentFileIndex !== totalFiles}
          onClick={() => handleModalState(false)}
        />
      </StyledButtonWrapper>
    </StyledUploadContent>
  );
};

export default UploadingFilesTsoPq;
